import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AboutModalComponent } from './about-modal.component';
var AboutModalModule = /** @class */ (function () {
    function AboutModalModule() {
    }
    AboutModalModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [AboutModalComponent],
                    exports: [AboutModalComponent]
                },] },
    ];
    /** @nocollapse */
    AboutModalModule.ctorParameters = function () { return []; };
    return AboutModalModule;
}());
export { AboutModalModule };
//# sourceMappingURL=about-modal.module.js.map